import { usePostHogOrganizationAnalytics } from '../../hooks/usePostHogOrganizationAnalytics';

/** Sincroniza group analytics da organização ativa. */
export function PostHogOrganizationAnalytics() {
  usePostHogOrganizationAnalytics();
  return null;
}
